var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 25 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.01.75A.75.75 0 0 1 3.76 0h16.5a.75.75 0 0 1 0 1.5H3.76a.75.75 0 0 1-.75-.75",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.26 0a.75.75 0 0 1 .75.75V12h-1.5V.75a.75.75 0 0 1 .75-.75M22.793 23.674l-8.532-8.887 1.14-.975 8.533 8.888zM1.51 23.674l8.533-8.887-1.14-.975L.37 22.7zM.263 9.94l2.749-2.441.995 1.122-.632 2.814-2.117-.374a.75.75 0 1 1-.995-1.122",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m21 12-1.213-3.358.947-1.164 3 2.44a.75.75 0 0 1 .108 1.055c-.26.322-2.52 1.288-2.842 1.027",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.26 9.75a.75.75 0 0 1 .75.75v12.75a.75.75 0 0 1-1.5 0V10.5a.75.75 0 0 1 .75-.75",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.309 15.759a.714.714 0 0 1 .409-.956l11.25-4.244a.79.79 0 0 1 .994.426.714.714 0 0 1-.409.956l-11.25 4.243a.79.79 0 0 1-.994-.426M.76 9.75a.75.75 0 0 0-.75.75v12.75a.75.75 0 0 0 1.5 0V10.5a.75.75 0 0 0-.75-.75",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.712 15.759a.79.79 0 0 1-.994.425L.468 11.94a.714.714 0 0 1-.41-.955.79.79 0 0 1 .995-.425l11.25 4.243c.388.146.571.574.41.955",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3.76 0a.75.75 0 0 1 .75.75V12h-1.5V.75A.75.75 0 0 1 3.76 0M23.26 24H.76v-1.5h22.5zM10.021 6.01c-.663-.373-1.34.466-.836 1.036l2.762 3.122c.03.034.082.034.112 0l2.762-3.122c.504-.57-.173-1.409-.836-1.036l-1.982 1.114zM8.174 7.94c-1.513-1.71.52-4.225 2.51-3.107l1.319.743 1.32-.743c1.99-1.118 4.021 1.398 2.509 3.107l-2.762 3.122a1.425 1.425 0 0 1-2.134 0z",
  clipRule: "evenodd"
})));
export default SvgEnvelope;